import { render, staticRenderFns } from "./RegistrationPage.vue?vue&type=template&id=7df72ca8&scoped=true&"
import script from "./RegistrationPage.vue?vue&type=script&lang=js&"
export * from "./RegistrationPage.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationPage.vue?vue&type=style&index=0&id=7df72ca8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df72ca8",
  null
  
)

export default component.exports